module.exports = __webpack_public_path__ + "static/media/mcf7_pacli_table.9067484b.png";